import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { updateProps } from '../../../../stores/newsfeed/actions';
import { Card, CardText, CircularProgress, CardHeader, FontIcon } from 'material-ui';
import R from 'ramda';
import PhotoIcon from 'material-ui/svg-icons/editor/insert-photo';

class UploadFromMM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      selectedFiles: [],
    };
  }
  componentDidMount() {
    this.props.setClear(this.clearSelections);
  }
  clearSelections = () => {
    this.setState({ selectedFiles: [], expanded: false });
  }
  render() {
    const {
      disableOpen,
      extraTitle,
      loadingFiles,
      MMFiles,
      onCardExpand,
      onChangeSelection,
      savingPost,
      style,
    } = this.props;

    const { selectedFiles, expanded } = this.state;

    return (
      <Card
        expanded={expanded}
        onExpandChange={(newExpadedState) => {
          if (!savingPost) {
            this.setState({
              expanded: newExpadedState,
            }, () => onCardExpand(newExpadedState));
          }
        }}
        style={{ boxShadow: 'none', borderBottom: '1px solid #e0e0e0', ...style }}
      >
        <CardHeader
          textStyle={{ display: 'none' }}
          {...(disableOpen ? {} : { showExpandableButton: true, actAsExpander: true })}
        >
          <FontIcon style={{ width: '100%' }}>
            <PhotoIcon color={'rgba(0, 0, 0, 0.54)'} style={{ verticalAlign: 'bottom' }} />
            <div style={{ display: 'inline-block', width: '80%', overflow: 'hidden', fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginLeft: '15px' }}>
              Marketing Materials
              {selectedFiles.length > 0 && !expanded &&
                <span> - <span style={{ color: '#00bcd4' }}>{R.propOr(0, 'length', selectedFiles)} of {R.propOr(0, 'length', MMFiles)} selected</span></span>}
              {extraTitle ? ` ${extraTitle}` : undefined}
            </div>
          </FontIcon>
        </CardHeader>
        <CardText expandable style={{ padding: '0' }}>
          {
            R.call(R.cond([
              [R.equals(true), R.always(
                <div>
                  Loading Marketing Material Photos...
                  <br/><br/>
                  <CircularProgress size={30} />
                </div>)],
              [R.equals(false), R.always(
                <div style={{ clear: 'both', padding: '8px 0 0 4px', maxHeight: '250px', overflowY: 'scroll' }}>
                  {
                    MMFiles.map((file, i) => {
                      const isSelected = R.contains(file.url, R.pluck('url')(selectedFiles));
                      const imgStyle = { border: isSelected ? '' : '1px solid #D3D3D3', borderRadius: '3px', cursor: 'pointer', marginRight: '10px' };
                      return (
                        <div
                          key={i}
                          onTouchTap={R.ifElse(
                            () => R.contains(file.url, R.pluck('url')(selectedFiles)),
                              () => {
                                this.setState({ selectedFiles: selectedFiles.filter(object => object.url !== file.url) }, () => {
                                  onChangeSelection(this.state.selectedFiles);
                                });
                              },
                            () => {
                              this.setState({ selectedFiles: R.prepend(file, selectedFiles) }, () => {
                                onChangeSelection(this.state.selectedFiles);
                              });
                            }
                          )}
                          style={{ display: 'inline-block' }}
                        >
                          <img
                            src={file.url}
                            height="75"
                            style={isSelected ? R.merge(imgStyle, { outline: '2px solid #00bcd4' }) : imgStyle}
                            title={R.propOr('', 'name', file)}
                          />
                        </div>
                      );
                    })
                  }
                </div>
              )],
              [R.T, R.always(<span/>)],
            ]), loadingFiles)
          }
        </CardText>
      </Card>
    );
  }
}

UploadFromMM.propTypes = {
  disableOpen: PropTypes.bool.isRequired,
  extraTitle: PropTypes.string,
  loadingFiles: PropTypes.bool,
  MMFiles: PropTypes.array,
  onCardExpand: PropTypes.func.isRequired,
  onChangeSelection: PropTypes.func.isRequired,
  savingPost: PropTypes.bool.isRequired,
  setClear: PropTypes.func,
  style: PropTypes.object.isRequired,
  updateProp: PropTypes.func,
};

UploadFromMM.defaultProps = {
  disableOpen: false,
  extraTitle: '',
  onCardExpand: () => {},
  onChangeSelection: () => {},
  savingPost: false,
  setClear: () => {},
  style: {},
};

const mapStateToProps = ({ profile }) => ({
  MMFiles: (profile.get('media')) ? profile.get('media').toJS() : [],
  loadingFiles: !profile.get('media'),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadFromMM);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/newPost/uploadFromMM.jsx